function toggleInViewClass(trigger, windowScrollY, windowHight, offsetHight) {
  if (windowScrollY + windowHight > trigger.offsetTop + offsetHight) {
    trigger.classList.add('is-in-view');
    // } else if (windowScrollY + windowHight < trigger.offsetTop) {
    //   trigger.classList.remove('is-in-view');
    // }
  }
}

function toggleScrolledClass(element, windowScrollY, offsetHight) {
  if (windowScrollY > offsetHight) {
    element.classList.add('is-scrolled');
  } else {
    element.classList.remove('is-scrolled');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const inViewTriggers = document.querySelectorAll('.js-inViewTrigger');
  const header = document.querySelector('.js-header');
  const pageTop = document.querySelector('.js-pageTop');

  function inView() {
    const windowScrollY = window.scrollY;
    const windowHight = window.innerHeight;
    const offsetHight = windowHight / 3;
    inViewTriggers.forEach((trigger) => {
      toggleInViewClass(trigger, windowScrollY, windowHight, offsetHight);
    });
  }

  function toggleHeaderAndPageTop() {
    const offsetHight = 200;
    toggleScrolledClass(header, window.scrollY, offsetHight);
    toggleScrolledClass(pageTop, window.scrollY, offsetHight);
  }

  inView();
  toggleHeaderAndPageTop();

  window.addEventListener('scroll', function () {
    inView();
    toggleHeaderAndPageTop();
  });
});
